<template>
    <div class="flex-grow flex-1">
        <div
            v-for="dateObj in activeSessions"
            :key="dateObj.date"
            class="mb-6 pb-6 border-tertiary-dark"
            :class="{ 'border-b-4': agenda.activeDate == '' }"
        >
            <div class="pr-6 mb-8">
                <h2 class="text-midwinter-dark--blue text-date text-3xl" style="
                    font-family: 'Lato';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 36px;
                    line-height: 43px;
                    color: #4A4A4A;
                ">{{ dateObj.full }}</h2>
            </div>
            <ConfAgendaSession
                v-for="session in sortSessions(dateObj.items)"
                :key="session.id"
                :data="session"
                :isExpanded="!agenda.collapseAll || isAnchoredLink(session.id)"
                :isAnchored="isAnchoredLink(session.id)"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ConfAgendaSession from "./ConfAgendaSession";

export default {
    components: {
        ConfAgendaSession
    },
    computed: {
        ...mapGetters(["activeSessions"]),
        ...mapState(["agenda"]),
        hasAnchorLink() {
            var url = window.location.href;
            return url.indexOf("#") > 0;
        }
    },
    methods: {
        isAnchoredLink(id){
            let anchored_id = window.location.href.split("#").pop()
            return anchored_id == id
        },
        getSessionIdLinked() {
            let url = window.location.href;
            if (this.hasAnchorLink) {
                url = url.substring(url.indexOf("#") + 1);
            }
            return url;
        },
        sortSessions(sessions) {
            const newSessions = [...sessions];
            newSessions.sort((a, b) => {
                // start time
                if (a.start > b.start) {
                    return 1;
                }
                if (a.start < b.start) {
                    return -1;
                }

                if(a.order != null && b.order != null){
                    if(a.order > b.order) return 1;
                    if(a.order < b.order) return -1;
                }else if(a.start == b.start){
                    if(a.order != null && b.order == null) return -1
                    if(a.order == null && b.order != null) return 1
                }

                // end time
                if (a.end > b.end) {
                    return 1;
                }
                if (a.end < b.end) {
                    return -1;
                }

                // track number
                if (a.track && b.track) {
                    if (a.track.number > b.track.number) {
                        return 1;
                    }
                    if (a.track.number < b.track.number) {
                        return -1;
                    }
                }

                // title
                return a.title.localeCompare(b.title);
            });
            

            return newSessions;
        }
    }
};
</script>

<style>
    h2.text-date {
        font-family: 'Lato';
        font-style: normal;
        font-weight: 600;
        font-size: 36px;
        line-height: 43px;
        color: #4A4A4A;
    }
</style>



// WEBPACK FOOTER //
// src/js/vue-components/conference-agenda/ConfAgendaSessions.vue